/* import __COLOCATED_TEMPLATE__ from './seller-application-card.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { APPLICATION } from 'sh-www/models/application';
import { ASSIGNMENT } from 'sh-www/models/assignment';
import { htmlEntitiesDecode } from 'sh-www/utils/misc';
import { htmlSafe } from '@ember/template';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-seller-application-card';

const CARD_TYPE_PRIMARY = 'primary';
const CARD_TYPE_SECONDARY = 'secondary';

class SellerApplicationCard extends Component {
  @service('commands/application-commands') applicationCommandService;
  @service constants;
  @service media;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.cardType === CARD_TYPE_PRIMARY && `${CLASS_NAME}--primary`,
      this.cardType === CARD_TYPE_SECONDARY && `${CLASS_NAME}--secondary`,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get brandOrCompanyName() {
    const { brand, company } = this.args.application;
    return htmlSafe(brand?.displayedName ?? company.name);
  }

  get assignmentTitle() {
    return htmlEntitiesDecode(this.args.application.assignment.titleWithUrgent).trim();
  }

  get pitchHeadline() {
    return htmlEntitiesDecode(this.args.application.pitch.headline);
  }

  get cardType() {
    return this.args.cardType || CARD_TYPE_PRIMARY;
  }

  get inHiredState() {
    const { status } = this.args.application;
    return APPLICATION.SIMPLE_STATUS_MAPPING[APPLICATION.SIMPLE_STATUS.HIRED].includes(status);
  }

  get isCallForPitches() {
    const { assignment } = this.args.application;
    return assignment.type === ASSIGNMENT.TYPES.PITCH;
  }
}

export default SellerApplicationCard;
